export default {"src":"/_next/static/media/Chronic_Angina.c191a16e.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};